export const GET_PROJECT_MANUFACTURERS = 'projectManufacturers/GET_PROJECT_MANUFACTURERS';
export const GET_PROJECT_MANUFACTURERS_SUCCESS =
  'projectManufacturers/GET_PROJECT_MANUFACTURERS_SUCCESS';
export const GET_PROJECT_MANUFACTURERS_ERROR =
  'projectManufacturers/GET_PROJECT_MANUFACTURERS_ERROR';
